import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {fullPath, setURLParams} from 'BenchlingUtil';
import {GRAY_DARKER, GRAY_LIGHTER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function ToolbarSignupMessage({action}: {action: string}): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <BenchlingIcon icon="info-circle" className={css(styles.icon)} />
      <span>
        <a href={setURLParams('/signup', {next: fullPath()})}>Sign up</a> for a Benchling account to {action}.
      </span>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: GRAY_LIGHTER,
    padding: '10px',
    display: 'flex',
    marginTop: '10px',
  },
  icon: {
    marginRight: '5px',
    marginTop: '3px',
    flexShrink: 0,
    color: GRAY_DARKER,
  },
});
